document.querySelector(".product-facet_quickView")?.addEventListener("click", function() {
        this.closest(".product-facet")?.classList.toggle("quick_product_items");
    });
const htmlElement = document.documentElement;
const stickyBarEnabled = getComputedStyle(htmlElement).getPropertyValue('--enable-sticky-announcement-bar').trim();
const announcement_bar_height = htmlElement.style.getPropertyValue('--announcement-bar-height').trim().replace("px", "") * 1
window.addEventListener("scroll",function() {
if (stickyBarEnabled === '0') {
  if (window.scrollY > announcement_bar_height) {
     document.querySelector("#mobile-menu-drawer").style.setProperty("--announcement-bar-height", "0px");
     document.querySelector("#search-drawer").style.setProperty("--announcement-bar-height", "0px");
   }else{
    let diff_top = announcement_bar_height - window.scrollY
     document.querySelector("#mobile-menu-drawer").style.setProperty("--announcement-bar-height", diff_top+"px");
     document.querySelector("#search-drawer").style.setProperty("--announcement-bar-height", diff_top+"px");
   }
}
});
document.addEventListener("click", function(e) {
    console.log(111);
    console.log(e.target);
  if (e.target.matches("input[type='radio'][name='Lenses']")) {
    const prev = e.target.getAttribute("previous-value");
    console.log("previous-value:", prev);
  }
});
